import { render, staticRenderFns } from "./ModeratorMenu.vue?vue&type=template&id=9ce0e3e4&scoped=true&"
import script from "./ModeratorMenu.vue?vue&type=script&lang=js&"
export * from "./ModeratorMenu.vue?vue&type=script&lang=js&"
import style0 from "./ModeratorMenu.vue?vue&type=style&index=0&id=9ce0e3e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ce0e3e4",
  null
  
)

export default component.exports